const BYTES_PER_MEGABYTE = 1024 * 1024;

/**
 * File size label in megabytes with one decimal, for example `1.4 MB`.
 * One megabyte is 1024×1024 bytes.
 */
export const formatFileSizeMegabytes = (sizeBytes: number): string =>
  `${(sizeBytes / BYTES_PER_MEGABYTE).toFixed(1)} MB`;
